import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from './login.service';
import { AuthService } from '../auth.service';
import { LocalService } from '../../../services/local.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule,TranslateModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {

  submitted = false;
  fieldTextType!: boolean;
  error = '';
  returnUrl!: string;
  get f() { return this.loginForm.controls; }
  year: number = new Date().getFullYear();
  loginForm = new FormGroup({
    email: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required, Validators.minLength(6)])
  })

  constructor(
    private router: Router,
    private loginService: LoginService,
    private authService: AuthService,
    private localService: LocalService,
    private translateService: TranslateService,
    public toaster: ToastrService,
  ) {}

  ngOnInit(): void {
    if (sessionStorage.getItem('currentUser')) {
      this.router.navigate(['/']);
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }
    let lang = localStorage.getItem('locale') ?? 'de'
    const data = {
      email: this.loginForm.value.email,
      password: this.loginForm.value.password,
      language: lang,
      weblogin: true
    }
    this.loginService.loginUser(data).subscribe((res: any) => {
      if (res['success']) {
        this.toaster.success(this.translateService.instant(res.message));

        this.localService.setJsonValue('loginUserData', JSON.stringify(res['userdata']));
        //this.localService.setJsonValue('access_token', res['userdata'].access_token);

        localStorage.setItem('locale',lang);

        this.router.navigate(['/user/dashboard']);
        this.authService.user.next(res.userdata);

        const loginTimestamp = new Date().getTime();
        this.localService.setJsonValue('loginTimestamp', loginTimestamp);
      }else{
        this.toaster.error(this.translateService.instant(res.message));
      }
    });
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  goToForgotPage() {
    this.router.navigate(['/auth/forgot-password']);
  }

}
